<div class='ili-panel disqus_panel'>
  <div class="input-group input-group-sm disqus_main_content">
    <mat-checkbox value="true" [checked]="block.data.disqus" [(ngModel)]="block.data.disqus" (change)="onChange($event)">Enable disqus</mat-checkbox>
  </div>
</div>
